import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchPartnerTypes } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function PartnerTypeListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try { setRows(await fetchPartnerTypes(businessDomainId)); }
    catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, [businessDomainId]);

  const columns = [
    { field: "partnerTypeName", headerName: t("partnerType.name"), flex: 1, minWidth: 200 },
    { field: "partnerTypeDescription", headerName: t("partnerType.description"), flex: 1, minWidth: 200 },
  ];

  const handleRowClick = (params) => {
    navigate(`/design/${businessDomainId}/partner-types/${params.row.partnerTypeId}`);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("partnerType.list.title")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/design/${businessDomainId}/partner-types/create`)}>{t("common.add")}</Button>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.partnerTypeId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        disableRowSelectionOnClick
        onRowClick={handleRowClick}
        sx={{
          "& .MuiDataGrid-row": { cursor: "pointer" },
          "& .MuiDataGrid-row:hover": { backgroundColor: "action.hover" },
        }}
      />
    </Box>
  );
}
